import React, { createContext, useContext, useEffect } from "react"

import { Tour } from "antd"
import classNames from "classnames"
import PropTypes from "prop-types"

import "./styles.less"

const TourCloseContext = createContext(null);

export const useTourClose = () => useContext(TourCloseContext);

export const TourComponent = ({ className, getPopupContainer, isClosableOnMaskClick, ...props }) => {
  useEffect(() => {
    const pageScroll = document.getElementById("global-wrap")
    if (!pageScroll || !props.open) return
    pageScroll.style.overflow = "hidden"
    return () => {
      pageScroll.style.overflow = ""
    }
  }, [props.open])

  useEffect(() => {
    if (!isClosableOnMaskClick) return
    const handler = (e) => {
      const tour = document.querySelector(".ant-tour")
      const modal = document.querySelector(".ant-modal")
      const previewOverlay = document.querySelector(".image-preview-overlay")
      if (tour && !tour.contains(e.target) && !modal && !previewOverlay) {
        props.onClose?.("mask")
      }
    }

    document.addEventListener("mousedown", handler)
    return () => document.removeEventListener("mousedown", handler)
  }, [isClosableOnMaskClick, props.onClose])

  const requestClose = () => props.onClose?.("mask")

  return (
    <TourCloseContext.Provider value={requestClose}>
      <Tour
        rootClassName={classNames("custom-tour-guide", className)}
        getPopupContainer={getPopupContainer ?? (() => document.getElementById("main-layout"))}
        {...props}
      />
    </TourCloseContext.Provider>
  )
}

TourComponent.propTypes = {
  className: PropTypes.string
}

export default TourComponent
